module.exports = __webpack_public_path__ + "static/media/td.e5cac5d5.svg";